import { BaseMapInfoWindowBuilder } from "../../../../_shared/interfaces/maps/base-map-info-window-builder";

export class FuelChangesMapInfoWindowBuilder extends BaseMapInfoWindowBuilder {
  constructor(private readonly translate: (key: string) => string) {
    super();
  }

  private label(key: string): string {
    return this.escapeHTML(this.translate(key));
  }

	private numberFormatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 });

	override buildMapInfoWindowHTML(data: any, currencySymbol: string = 'R'): string {
		const signMultiplier = data.type === 'Fill-Up' ? 1 : -1;
		const vehicle = this.escapeHTML(data.vehicle);
		const driver = this.escapeHTML(data.driver);
		const amount = isFinite(Number(data.amount)) ? `${this.numberFormatter.format(Number(data.amount) * signMultiplier)} ℓ` : this.label('fuelShared.charts.notAvailable');
		const tank = isFinite(Number(data.tank)) && data.tank > 0 ? this.numberFormatter.format(Number(data.tank)) : this.label('fuelShared.charts.notAvailable')
		const fuelConsumption = isFinite(Number(data.fuelConsumption)) ? `${this.numberFormatter.format(Number(data.fuelConsumption))} ℓ/100km` : this.label('fuelShared.charts.notAvailable')
		const cost = isFinite(Number(data.cost)) ? `${currencySymbol}${this.numberFormatter.format(Number(data.cost))}` : `${currencySymbol}0`;
		const location = this.escapeHTML(data.location);
		const timestamp = this.formatDateTime(data.timestamp);
		const lat = data.lat;
		const lng = data.lng;

		const currentFuelLevel = data.isValidFuelLevel
			? `${this.numberFormatter.format(Number(data.currentFuelLevel))} ℓ`
			: this.label('fuelShared.charts.notAvailable');

		const fuelLevelBeforeChange = data.isValidFuelLevelBeforeChange
			? `${this.numberFormatter.format(Number(data.fuelLevelBeforeChange))} ℓ`
			: this.label('fuelShared.charts.notAvailable');

		const fuelLevelAfterChange = data.isValidFuelLevelAfterChange
			? `${this.numberFormatter.format(Number(data.fuelLevelAfterChange))} ℓ`
			: this.label('fuelShared.charts.notAvailable');

		const distanceUntilEmpty = isFinite(Number(data.distanceUntilEmpty))
			? `${this.numberFormatter.format(Number(data.distanceUntilEmpty))} km`
			: this.label('fuelShared.charts.notAvailable');

		return `
        <div class="fc-iw">
          <style>
            .gm-style-iw-ch { 
              padding: 0 !important;
            }
    
            .gm-style-iw-d { 
              max-height: none !important;
              overflow: visible !important;
              overflow-x: hidden !important; 
            }
    
            .gm-style-iw, .gm-style-iw-c {
              max-width: none !important;
              overflow: visible !important;
              padding: 16px !important;
              height: 300px !important;
              width: 320px !important;
            }
    
            /* Rows layout: two columns (label + value), single-line, spaced vertically */
            .fc-iw .rows {
              display: grid;
              grid-template-columns: auto 1fr;
              column-gap: 12px;
              row-gap: 8px;
              align-items: start;
            }
    
            .fc-iw .label {
              color: #9FA1A4;
              font-weight: 400;
              align-self: start;
            }
    
            .fc-iw .val {
              align-self: start;
              overflow-wrap: anywhere;
              line-height: 1.25;
            }
          </style>
    
          <div class="rows">
            <div class="label">${this.label('fuelShared.map.driver')}</div>                    <div class="val">${driver}</div>
            <div class="label">${this.label('fuelShared.map.vehicle')}</div>                   <div class="val">${vehicle}</div>
            <div class="label">${this.label('fuelShared.map.location')}</div>                  <div class="val">${location}</div>
            <div class="label">${this.label('fuelShared.map.timestamp')}</div>                <div class="val">${timestamp}</div>
            <div class="label">${this.label('fuelShared.map.fuelChange')}</div>           <div class="val">${amount}</div>
            <div class="label">${this.label('fuelShared.map.fuelChangeCost')}</div>          <div class="val">${cost}</div>
            <div class="label">${this.label('fuelShared.map.fuelBeforeChange')}</div>    <div class="val">${fuelLevelBeforeChange}</div>
            <div class="label">${this.label('fuelShared.map.fuelAfterChange')}</div>     <div class="val">${fuelLevelAfterChange}</div>
            <div class="label">${this.label('fuelShared.map.fuelLevelWithUnit')}</div>            <div class="val">${currentFuelLevel}</div>
            <div class="label">${this.label('fuelShared.map.distanceToEmpty')}</div>         <div class="val">${distanceUntilEmpty}</div>
            <!--<div class="label">Tank:</div>                      <div class="val">${tank}</div>-->
            <!--<div class="label">Fuel Consumption:</div>          <div class="val">${fuelConsumption}</div>-->
            <!--<div class="label">Latitude:</div>                  <div class="val">${lat}</div>-->
            <!--<div class="label">Longitude:</div>                 <div class="val">${lng}</div>-->
          </div>
        </div>
     `;
	}
}